// extracted by mini-css-extract-plugin
export default {"root":"IconLocalDeliveryBox_root__3NJp1"};